// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
/**
 * HistoryType indicates what type the communication history was.
 * It is an enum because this list could easily grow and change as
 * more types get added.
 */
export var HistoryType;
(function (HistoryType) {
    HistoryType["HISTORY_TYPE_UNSPECIFIED"] = "HISTORY_TYPE_UNSPECIFIED";
    HistoryType["HISTORY_TYPE_SMS"] = "HISTORY_TYPE_SMS";
    HistoryType["HISTORY_TYPE_PHONE"] = "HISTORY_TYPE_PHONE";
})(HistoryType || (HistoryType = {}));
export var HistoryType_index;
(function (HistoryType_index) {
    HistoryType_index[HistoryType_index["HISTORY_TYPE_UNSPECIFIED"] = 0] = "HISTORY_TYPE_UNSPECIFIED";
    HistoryType_index[HistoryType_index["HISTORY_TYPE_SMS"] = 1] = "HISTORY_TYPE_SMS";
    HistoryType_index[HistoryType_index["HISTORY_TYPE_PHONE"] = 2] = "HISTORY_TYPE_PHONE";
})(HistoryType_index || (HistoryType_index = {}));
export const CommHistoryService = {
    /**
     * GetHistory gets the sms and call history.
     */
    GetHistory(fn, req) {
        return fn(`/comm/history/v1?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
